<template>
  <transition name="fade">
    <div
      v-show="$store.state.show === 'page3'"
      :class="['page page3', $store.state.show === 'page3' ? 'active' : '']"
    >
      <div class="content">
        <div class="cont">
          <div :class="['screen screen1', $store.state.screen === 'screen7' ? 'active' : '' ? 'active' : '']">
            <img src="./images/p3-p1-chuanjia.gif" alt="" class="p1-chuanjia abs opacity" />
            <img src="./images/p3-p1-text.png" alt="" class="p1-text abs opacity" />
          </div>

          <div :class="['screen screen2', $store.state.screen === 'screen8' ? 'active' : '' ? 'active' : '']">
            <img src="./images/p3-p2-diaoxiang.gif" alt="" class="p2-diaoxiang p2-diaoxiang1 abs opacity" />
            <!-- <img src="./images/p3-p2-diaoxiang.png" alt="" class="p2-diaoxiang abs opacity" /> -->
            <img src="./images/p3-p2-text.png" alt="" class="p2-text abs opacity" />
          </div>

          <img src="./images/p3-p1-molihua.png" alt="" class="p1-molihua abs" />
        </div>
        <img src="./images/yun-zuo.png" alt="" class="yun-zuo abs" />
        <img src="./images/yun-you.png" alt="" class="yun-you abs" />
        <img :class="['tips-up abs']" src="./images/tips-up.png" alt="" />
      </div>
    </div>
  </transition>
</template>

<script>
import $ from "jquery";
export default {
  name: "page3",
  components: {},
  data() {
    return {};
  },
  methods: {
    // 下一页
    nextPage() {
      this.$store.dispatch("setPageFn", "page3");
    },
  },
  mounted() {
  },
  watch: {
    "$store.state.show"() {
      // 你需要执行的代码
      if (this.$store.state.show === "page3") {
        // this.pageOperate();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/mixin";

.page3 {
  background: url("./images/p3-p1-bg.jpg") top center no-repeat;
  background-size: 100% auto;

  .screen1.active,
  .screen2.active {
    .p1-text,
    .p2-text  {
      -webkit-animation: identifieryu 0.6s ease-out;
      animation: identifieryu 0.6s ease-out;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
    .p1-chuanjia,
    .p2-diaoxiang {
      -webkit-animation: identifieryu 0.6s ease-out 0.2s;
      animation: identifieryu 0.6s ease-out 0.2s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
  }

  .screen4 {
    z-index: 13;
  }

  .content {
    .p1-chuanjia {
      bottom: 0;
      right: 0;
      width: 747px;
    }

    .p1-text {
      top: 311px;
      left: 65px;
      width: 600px;
    }

    .p1-molihua {
      width: 100%;
      bottom: 0;
      left: 0;
      z-index: 40;
    }

    .p2-diaoxiang {
      bottom: 0;
      left: 130px;
      width: 404px;
    }

    .p2-diaoxiang1 {
      bottom: -420px;
      left: -70px;
      width: 854px;
      z-index: 10;
    }

    .p2-text {
      top: 331px;
      left: 148px;
      width: 536px;
    }
  }
}
</style>
